import { isPrimaryPersistedTab } from 'apiConnector/tabs/tabs.model';
import type { Action } from 'state/actions';
import { addOrPatchKey, removeKey } from 'state/utils/collection';

import type { DynamicWorkspaceState, DynamicWorkspaceStateMap } from './dynamic.model';
import { initialDynamicWorkspaceState } from './dynamic.model';

export function dynamicWorkspacesReducer(
  state: DynamicWorkspaceStateMap = initialDynamicWorkspaceState,
  action: Action,
): DynamicWorkspaceStateMap {
  switch (action.type) {
    case 'WORKSPACE_PERSISTED_TABS_APPLIED':
      return action.tabs.reduce((oldState, tab) => {
        if (isPrimaryPersistedTab(tab) && tab.workspace === 'dynamic') {
          return addOrPatchKey(oldState, tab.id, () => ({ quoteId: tab.quoteId }) as DynamicWorkspaceState);
        }
        return oldState;
      }, state);
    case 'DYNAMIC_WORKSPACE_SET_QUOTE':
      const patched: Partial<DynamicWorkspaceState> = { quoteId: action.quoteId };
      return addOrPatchKey(state, action.tabId, () => patched);
    case 'DYNAMIC_WORKSPACE_UNSET_QUOTE':
      return removeKey(state, action.tabId);
    case 'WORKSPACE_TAB_CONTENT_FETCH_REQUESTED':
      if (action.workspace !== 'dynamic') {
        return state;
      }
      return addOrPatchKey(state, action.tabId, () => ({ isFetchingTabContent: true }));
    case 'WORKSPACE_TAB_CONTENT_FETCHED':
      if (action.workspace !== 'dynamic') {
        return state;
      }
      return addOrPatchKey(state, action.tabId, () => ({ isFetchingTabContent: false }));
    case 'WORKSPACE_TAB_CONTENT_FETCH_FAILED':
      if (action.workspace !== 'dynamic') {
        return state;
      }
      return addOrPatchKey(state, action.tabId, () => ({
        isChoosingProduct: action.tabType !== 'reprice',
        isFetchingTabContent: false,
      }));
    case 'WORKSPACE_TAB_CREATED':
      if (action.workspace !== 'dynamic') {
        return state;
      }
      return addOrPatchKey(state, action.id, () => ({
        isChoosingProduct: true,
        isFetchingTabContent: true,
      }));
    case 'WORKSPACE_TAB_PRODUCT_SELECTION_SUBMITTED':
      if (action.workspaceType !== 'dynamic') {
        return state;
      }
      return addOrPatchKey(state, action.tabId, () => ({
        isChoosingProduct: false,
        isFetchingTabContent: true,
        productVariation: action.productVariation,
        client: action.client,
      }));
    default:
      return state;
  }
}
